import repository from '@/api'
import { AuthenticatedUserAccount } from 'eop-ui-core/types/AuthenticatedUserAccount'
import { buildFcmTokenHeader } from '@/constants'
import { AUTH_API_URL, AUTH_PROVIDER_URL } from '@/constants/env'

export default {
  signIn({ username, password }, onError) {
    return repository.post<AuthenticatedUserAccount>(
      `/v1/sign-in`,
      { username, password },
      { onError, baseURL: AUTH_API_URL.replace('pw', '_pw'), headers: buildFcmTokenHeader() },
    )
  },
  signInBySsoKey(ssoKey, onError) {
    return repository.post<AuthenticatedUserAccount>(
      `/v1/sign-in`,
      { ssoKey },
      { onError, baseURL: AUTH_API_URL.replace('pw', '_pw'), headers: buildFcmTokenHeader() },
    )
  },
  signOut() {
    return repository.delete(`/v1/sign-out`, undefined, { baseURL: AUTH_API_URL, headers: buildFcmTokenHeader() })
  },
  issueSmsPasscode({ username, mobileNo }, onError) {
    return repository.post(`/v1/sms-passcodes`, { username, mobileNo }, { onError, baseURL: AUTH_API_URL.replace('pw', '_pw') })
  },
  verifySmsPasscode(smsPasscodeId, { passcode, mobileNo, username }, onError) {
    return repository.post(
      `/v1/sms-passcodes/${smsPasscodeId}/verify`,
      { passcode, mobileNo, username },
      { onError, baseURL: AUTH_API_URL.replace('pw', '_pw') },
    )
  },
  issueAuthTicket() {
    return repository.post<{ authTicket: string }>(`/v2/issue-auth-ticket`, null)
  },
  // v2 인증 무력화
  unauthenticate({ username, fcmToken, userChannel }) {
    return fetch(`${AUTH_PROVIDER_URL}/gateway/v2/unauthenticate`, {
      body: new Blob([JSON.stringify({ username })], { type: 'application/json' }),
      headers:
        fcmToken && userChannel
          ? {
              'X-CNSAMC-FCM-TOKEN': fcmToken,
              'X-CNSAMC-USER-CHANNEL': userChannel,
            }
          : undefined,
      method: 'POST',
      mode: 'cors',
      credentials: 'include',
    })
  },
}
